var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.tasks,"headers":_vm.headers,"loading":_vm.loading,"no-data-text":"Brak kolejnych zaplanowanych zadań","items-per-page":3,"mobile-breakpoint":0,"hide-default-footer":true},scopedSlots:_vm._u([{key:"item.taskNumber",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.procNumber)+" ")]}},{key:"item.plate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseEmptyValue(item.procPlateNumber))+" ")]}},{key:"item.closedFormat",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseEmptyValue(item.orderObject && item.orderObject.closedFormat))+" ")]}},{key:"item.quantity",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.procTaskQuantity)+" ")]}},{key:"item.volume",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseEmptyValue(item.orderObject && item.orderObject.volume))+" ")]}},{key:"item.foldedSignaturesQuantity",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseEmptyValue(item.orderObject && item.orderObject.foldedSignaturesQuantity))+" ")]}},{key:"item.coverStatus",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseEmptyValue(item.orderObject && item.orderObject.coverStatus))+" ")]}},{key:"item.innerStatus",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseEmptyValue(item.orderObject && item.orderObject.innerStatus))+" ")]}},{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.procTaskStartTime))+" ")]}},{key:"item.procTaskDuration",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseDuration(item.procTaskDurationSeconds))+" ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("lowercase")(item.procStatus))+" ")]}},{key:"item.productionProcessFB",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.parseEmptyValue(item.productionProcessFB && item.productionProcessFB.name))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }